<template>
  <div class="app-container">
    <div class="title">
      <div class="title--font">
        {{ topTitle }}
      </div>
      <div class="title--button"></div>
    </div>
    <hr />
    <my-operate
      :id="'myOperate'"
      :titleList="titleList"
      :operationTitleData="operationTitleData"
      :titleOperationTitleData="titleOperationTitleData"
      :titleData="titleData"
      @titleOperationBtnClick="titleOperationBtnClick"
      @operationBtnClick="operationBtnClick"
      @onStart="onStart"
      @onEnd="onEnd"
      @isShowClick="isShowClick"
      @widthClick="widthClick"
      @resetClick="resetClick"
      ref="myOperate"
    >
    </my-operate>
    <myHtml
      v-loading="listLoading"
      :height="this.$root.tableHeight - 50"
      :id="'bill_one'"
      :columnType="columnType"
      :list="list"
      :titleList="titleList"
      :tableBtnList="tableBtnList"
      :checkKey="'purchasesOrderDocId'"
      :keyData="keyData"
      @btnClick="btnClick"
      @cellClickEvent="cellClickEvent"
      @resizableChange="resizableChange"
      @selectChangeEvent="selectChangeEvent"
      @selectAllCheckboxChange="selectAllCheckboxChange"
      :dialogStatus="1"
      ref="myTable"
    ></myHtml>
    <pagination
      :total="listQuery.total"
      :page.sync="listQuery.pageNum"
      :limit.sync="listQuery.pageSize"
      :page-sizes="[10, 20, 50, 100, 300]"
      style="text-align: right; float: right"
      @pagination="getList"
    />
    <div style="clear: both"></div>
    <!-- 发货 -->
    <myOrderAdd
      v-if="htmlDataDialogState.show1"
      :visible="htmlDataDialogState.show1"
      :homeIndex="homeIndex"
      :routeType="routeType"
      :routeQuery="routeQuery"
      @htmlDataDialogClose="htmlDataDialogClose"
    ></myOrderAdd>
    <!-- 详情 -->
    <myOrderDetails
      v-if="htmlDataDialogState.show2"
      :visible="htmlDataDialogState.show2"
      :homeIndex="homeIndex"
      :routeQuery="routeQuery"
      @htmlDataDialogClose="htmlDataDialogClose"
    ></myOrderDetails>
  </div>
</template>
<script>
import { selcetSetting, updateSetting, _debounce } from "@/utils/myUtils";
import {
  outsourcingDoc_vagueList,
  outsourcingDoc_getOutsourcingDoc,
} from "@/api/myController/outsourcing";
export default {
  name: "outsourcingProduct_order",
  props: {
    titleData: {
      type: Object,
      default: () => ({}),
    },
  },
  components: {},
  data() {
    return {
      // 新增、详情、修改
      htmlDataDialogState: {
        show1: false,
        show2: false,
        show3: false,
      },
      routeType: 0,
      routeQuery: {},
      homeIndex: 0,
      // ------------------------------
      type: 1,
      topTitle: "产品委外订单",
      listQuery: {
        total: 0,
        pageNum: 1,
        pageSize: 20,
      },
      changeList: [],
      // 操作栏数据
      operationTitleData: [],
      // 排序
      orderParam: {
        asc: false,
        dateAggregateBy: "",
        fieldName: "createTime",
      },
      // 操作栏数据
      titleOperationTitleData: [
        {
          name: "基本信息",
          value: "searchString",
          type: "text",
        },
        { name: "搜索", type: "button" },
      ],
      listLoading: false,
      columnType: "columnAll", // columnIndex序号,columnBox复选框
      // 按钮集合
      tableBtnList: ["详情", "发货"],
      // 表内容
      list: [],
      // 合并单元格 供应商编号、采购人、付款模式、已开票金额、未开票金额、已付款金额、未付款金额
      keyData: ["purchasesOrderDocId"],
      // 表头
      titleList: [
        {
          id: 0,
          name: "产品图片",
          value: "baseImgUrl",
          fixedState: false,
          isShow: true,
          dataType: "image",
          canEdit: false,
          width: 49,
          sort: 10,
        },
        {
          id: 6,
          name: "委外单编号",
          value: "outsourcingDocNumber",
          fixedState: false,
          isShow: true,
          dataType: "text",
          selectOptionKey: "",
          selectOptionList: [],
          alwaysEditState: false,
          canEdit: false,
          width: 91,
          color: "#409eff",
          sortable: true,
          sort: 20,
        },
        {
          id: 1,
          name: "全局搜索码",
          value: "globalSearchNumber",
          fixedState: false,
          isShow: false,
          dataType: "text",
          color: "#049eff",
          canEdit: false,
          width: 105,
          sort: 30,
        },

        {
          id: 3,
          name: "委外商名称",
          value: "baseOutsourcingSupplierName",
          fixedState: false,
          isShow: true,
          dataType: "text",
          selectOptionKey: "",
          selectOptionList: [],
          alwaysEditState: false,
          canEdit: false,
          width: 118,
          sortable: true,
          sort: 40,
        },
        {
          id: 4,
          name: "客户订单号",
          value: "baseCustomerSalesOrderNumber",
          fixedState: false,
          isShow: false,
          dataType: "text",
          selectOptionKey: "",
          selectOptionList: [],
          alwaysEditState: false,
          canEdit: false,
          width: 104,
          sortable: true,
          sort: 50,
        },
        {
          id: 2,
          name: "客户料号",
          value: "baseCustomerMaterialNumber",
          fixedState: false,
          isShow: false,
          dataType: "text",
          alwaysEditState: false,
          canEdit: false,
          width: 109,
          sort: 60,
        },
        {
          id: 0,
          name: "优先级",
          value: "priorityLevel",
          fixedState: false,
          isShow: true,
          dataType: "select",
          selectOptionKey: "sys_priority",
          selectOptionList: [],
          canEdit: false,
          width: 57,
          sortable: true,
          sort: 70,
        },
        {
          id: 8,
          name: "产品编号",
          value: "baseMaterialNumber",
          fixedState: false,
          isShow: true,
          dataType: "text",
          canEdit: false,
          width: 114,
          sort: 80,
        },
        {
          id: 9,
          name: "产品名称",
          value: "baseMaterialName",
          fixedState: false,
          isShow: true,
          dataType: "text",
          canEdit: false,
          width: 143,
          sort: 90,
        },
        {
          id: 10,
          name: "规格型号",
          value: "specifications",
          fixedState: false,
          isShow: true,
          dataType: "textList",
          canEdit: false,
          width: 182,
          sort: 100,
        },
        {
          id: 13,
          name: "订单数量",
          value: "baseOutsourcingQuantity",
          fixedState: false,
          isShow: true,
          dataType: "number",
          canEdit: false,
          width: 62,
          sort: 110,
        },
        {
          id: 18,
          name: "产品加工单价",
          value: "baseMaterialUnitprice",
          fixedState: false,
          isShow: true,
          dataType: "priceAccuracy",
          canEdit: false,
          width: 75,
          sort: 120,
        },
        {
          id: 18,
          name: "产品加工总价",
          value: "baseMaterialTotalprice",
          fixedState: false,
          isShow: true,
          dataType: "priceAccuracy",
          canEdit: false,
          width: 75,
          sort: 120,
        },
        {
          id: 18,
          name: "其他费用",
          value: "baseOtherTotalprice",
          fixedState: false,
          isShow: true,
          dataType: "priceAccuracy",
          canEdit: false,
          width: 61,
          sort: 130,
        },
        {
          id: 12,
          name: "成品仓库",
          value: "baseOutsorWarehouseName",
          fixedState: false,
          isShow: false,
          dataType: "text",
          canEdit: false,
          width: 180,
          sort: 140,
        },
        {
          id: 13,
          name: "发货数量",
          value: "valueInwarehouseQuantity",
          fixedState: false,
          isShow: true,
          dataType: "number",
          canEdit: false,
          width: 61,
          sort: 150,
        },
        {
          id: 13,
          name: "未收数量",
          value: "valueUnfinishedQuantity",
          fixedState: false,
          isShow: true,
          dataType: "number",
          canEdit: false,
          width: 55,
          sort: 160,
        },
        {
          id: 18,
          name: "交货日期",
          value: "valueOutsourcingDeliveryDate",
          fixedState: false,
          isShow: true,
          dataType: "dateTime",
          canEdit: false,
          width: 78,
          sortable: true,
          sort: 170,
        },
        {
          id: 15,
          name: "开始日期",
          value: "baseOutsourcingStartTime",
          fixedState: false,
          isShow: false,
          dataType: "dateTime",
          canEdit: false,
          width: 82,
          sort: 190,
        },
        {
          id: 17,
          name: "预计完成日期",
          value: "baseOutsourcingEndTime",
          fixedState: false,
          isShow: false,
          dataType: "dateTime",
          canEdit: false,
          width: 91,
          sortable: true,
          sort: 200,
        },
        {
          id: 5,
          name: "负责人",
          value: "baseOutsourcingChargemanName",
          fixedState: false,
          isShow: true,
          dataType: "text",
          selectOptionKey: "",
          selectOptionList: [],
          alwaysEditState: false,
          canEdit: false,
          width: 63,
          sortable: true,
          sort: 210,
        },
        {
          id: 7,
          name: "委外类型",
          value: "modelType",
          fixedState: false,
          isShow: false,
          dataType: "customSelect",
          selectOptionList: [
            {
              label: "成品委外",
              value: 1,
            },
            {
              label: "工序委外",
              value: 2,
            },
          ],
          canEdit: false,
          width: 76,
          sort: 220,
        },
        {
          id: 7,
          name: "付款模式",
          value: "modelCtrls",
          fixedState: false,
          isShow: false,
          dataType: "customSelect",
          selectOptionList: [
            {
              label: "现结",
              value: 0,
            },
            {
              label: "月结",
              value: 1,
            },
          ],
          canEdit: false,
          width: 69,
          sort: 230,
        },
        {
          id: 0,
          name: "产品图纸",
          value: "baseDrawingCount",
          fixedState: false,
          isShow: false,
          dataType: "number",
          canEdit: false,
          width: 60,
          sort: 240,
        },
        {
          id: 0,
          name: "产品附件",
          value: "baseFileCount",
          fixedState: false,
          isShow: false,
          dataType: "number",
          canEdit: false,
          width: 62,
          sort: 250,
        },
        {
          id: 0,
          name: "订单图片",
          value: "valueImgList",
          fixedState: false,
          isShow: false,
          dataType: "fileList",
          canEdit: false,
          width: 65,
          sort: 260,
        },
        {
          id: 0,
          name: "订单附件",
          value: "valueFileList",
          fixedState: false,
          isShow: true,
          dataType: "fileList",
          canEdit: false,
          width: 58,
          sort: 270,
        },
        {
          id: 14,
          name: "审核状态",
          value: "statusCheck",
          fixedState: false,
          isShow: true,
          dataType: "customSelect",
          selectOptionList: [
            {
              label: "已审核",
              value: 1,
              color: "white",
              backGroundColor: "rgb(103,194,58",
              fontSize: "",
            },
            {
              label: "未审核",
              value: 0,
              color: "black",
              backGroundColor: "rgb(220,223,230",
              fontSize: "",
            },
          ],
          canEdit: false,
          width: 65,
          sort: 280,
        },
        {
          id: 7,
          name: "委外单状态",
          value: "statusDoc",
          fixedState: false,
          isShow: true,
          dataType: "customSelect",
          selectOptionList: [
            {
              label: "进行中",
              value: 0,
              color: "white",
              backGroundColor: "rgb(102, 102, 102",
            },
            {
              label: "已完成",
              value: 1,
              color: "white",
              backGroundColor: "rgb(79,129,246",
            },
            {
              label: "已结束",
              value: 2,
              color: "white",
              backGroundColor: "rgb(106, 168, 79",
            },
          ],
          canEdit: false,
          width: 79,
          sort: 290,
        },
        {
          id: 7,
          name: "收料状态",
          value: "statusRequisition",
          fixedState: false,
          isShow: false,
          dataType: "customSelect",
          selectOptionList: [
            {
              label: "未收料",
              value: 0,
              color: "white",
              backGroundColor: "rgb(102, 102, 102",
            },
            {
              label: "部分收料",
              value: 1,
              color: "white",
              backGroundColor: "rgb(79,129,246",
            },
            {
              label: "完全收料",
              value: 2,
              color: "white",
              backGroundColor: "rgb(106, 168, 79",
            },
            {
              label: "超量收料",
              value: 3,
              color: "white",
              backGroundColor: "rgb(106, 168, 79",
            },
          ],
          canEdit: false,
          width: 84,
          sort: 300,
        },
        {
          id: 7,
          name: "对账状态",
          value: "statusReconcile",
          fixedState: false,
          isShow: false,
          dataType: "customSelect",
          selectOptionList: [
            {
              label: "未对账",
              value: 0,
              color: "white",
              backGroundColor: "rgb(102, 102, 102",
            },
            {
              label: "部分对账",
              value: 1,
              color: "white",
              backGroundColor: "rgb(79,129,246",
            },
            {
              label: "完全对账",
              value: 2,
              color: "white",
              backGroundColor: "rgb(106, 168, 79",
            },
            {
              label: "超量对账",
              value: 3,
              color: "white",
              backGroundColor: "rgb(106, 168, 79",
            },
          ],
          canEdit: false,
          width: 77,
          sort: 310,
        },

        {
          id: 7,
          name: "开票状态",
          value: "statusBilling",
          fixedState: false,
          isShow: false,
          dataType: "customSelect",
          selectOptionList: [
            {
              label: "未开票",
              value: 0,
              color: "white",
              backGroundColor: "rgb(102, 102, 102",
            },
            {
              label: "部分开票",
              value: 1,
              color: "white",
              backGroundColor: "rgb(79,129,246",
            },
            {
              label: "完全开票",
              value: 2,
              color: "white",
              backGroundColor: "rgb(106, 168, 79",
            },
            {
              label: "超量开票",
              value: 3,
              color: "white",
              backGroundColor: "rgb(106, 168, 79",
            },
          ],
          canEdit: false,
          width: 75,
          sort: 320,
        },
        {
          id: 28,
          name: "创建时间",
          value: "createTime",
          fixedState: false,
          isShow: true,
          dataType: "text",
          canEdit: false,
          width: 120,
          sort: 470,
        },
        {
          id: 29,
          name: "备注",
          value: "remark",
          fixedState: false,
          isShow: true,
          dataType: "textarea",
          canEdit: false,
          width: 180,
          sort: 330,
        },
      ],
    };
  },
  created() {
    this.getList();
  },
  methods: {
    getList() {
      this.listLoading = true;
      outsourcingDoc_vagueList({
        orderParam: [this.orderParam],
        outsourcingDocFilter: this.titleData,
        pageParam: this.listQuery,
      }).then((res) => {
        if (res.data.data.totalCount > 0) {
          res.data.data.dataList.forEach((item) => {
            try {
              item.specifications = JSON.parse(item.baseMaterialSpecDesc);
            } catch (error) {
              item.specifications = [];
            }
            try {
              if (item.baseBomVersion) {
                item.baseBomVersionV2 = "V" + item.baseBomVersion;
              } else {
                item.baseBomVersionV2 = "---";
              }
            } catch (error) {}
          });
          this.list = res.data.data.dataList;
          this.listQuery.total = res.data.data.totalCount;
        } else {
          this.list = [];
        }
        this.listLoading = false;
        this.$refs.myOperate?.dragSortShow();
      });
    },
    async titleOperationBtnClick(item, titleData) {
      switch (item.name) {
        case "搜索":
          this.getList();

        default:
          break;
      }
    },
    // 操作栏点击事件
    operationBtnClick(item, titleData) {
      switch (item.name) {
        case "搜索":
          this.getList();
          break;
        default:
          break;
      }
    },
    // 点击按钮
    async btnClick(row, item, index, state) {
      switch (item) {
        case "详情":
          this.routeQuery = row;
          this.homeIndex = 47;
          this.htmlDataDialogState.show2 = true;
          break;
        case "退料":
          outsourcingDoc_getOutsourcingDoc({
            outsourcingDocId: row.outsourcingDocId,
          }).then((res) => {
            if (res.data.data.outsourcingDocMaterialList.length > 0) {
              this.routeQuery = res.data.data;
              this.routeType = 1;
              this.homeIndex = 49;
              this.htmlDataDialogState.show1 = true;
            } else {
              this.$message.error("暂无可退物料！");
            }
          });

          break;
        case "发货":
          this.routeQuery = row;
          this.routeType = 1;
          this.homeIndex = 50;
          this.htmlDataDialogState.show1 = true;
          break;
        default:
          break;
      }
    },
    cellClickEvent(row, column) {
      switch (column.field) {
        case "outsourcingDocNumber":
          this.routeQuery = row;
          this.homeIndex = 47;
          this.htmlDataDialogState.show2 = true;
          break;

        default:
          break;
      }
    },
    changeType() {
      this.type = command;
    },
    // 多选
    selectChangeEvent(val) {
      this.changeList = val.records;
    },
    selectAllCheckboxChange(val) {
      this.changeList = val.records;
    },
    htmlDataDialogClose(state, data) {
      this.htmlDataDialogState.show1 = false;
      this.htmlDataDialogState.show2 = false;
      this.htmlDataDialogState.show3 = false;
      this.getList();
    },
    // 列宽拖动事件
    resizableChange(val) {
      this.titleList.forEach((item) => {
        if (item.value == val.field && item.name == val.title) {
          item.width = val.renderWidth;
        }
      });
    },
    // 开始拖拽事件
    onStart(titleList) {},
    // 拖拽结束事件
    onEnd(titleList) {
      this.titleList = titleList;
    },
    // 复选框事件
    isShowClick(titleList) {
      this.titleList = titleList;
    },
    // 固定方向事件
    widthClick(titleList) {
      this.titleList = titleList;
    },
    // 重置
    async resetClick(titleList) {
      this.titleList = titleList;
    },
  },
};
</script>

<style rel="stylesheet/scss" lang="scss" scoped>
.title {
  display: flex;
  position: relative;
  margin-bottom: 10px;
  /* flex-direction: row ;
      justify-content:center; */
}

.title----font {
  color: #1476c3;
  position: relative;
  margin-left: 47%;
  font-size: 25px;
  font-weight: bold;
}

.title--button {
  position: absolute;
  margin-left: 1px;
  margin-top: 0.1%;
}

.spanText {
  color: #1476c3;
  font-size: 14px;
}

.operations {
  float: left;
  width: 200px;
  padding-top: 6px;
}

/*  修改页面样式 */

.title--font {
  text-align: left;
  padding: 10px 0;
}
::v-deep .operation {
  margin-bottom: 10px;
}
::v-deep .el-input--mini .el-input__inner {
  height: 34px;
  line-height: 34px;
}
::v-deep .el-pagination span:not([class*="suffix"]),
.el-pagination button {
  display: inline-block;
  font-size: 13px;
  min-width: 35.5px;
  height: 34px;
  line-height: 34px;
  vertical-align: top;
  -webkit-box-sizing: border-box;
  box-sizing: border-box;
}
::v-deep .el-pagination__editor.el-input .el-input__inner {
  height: 34px;
}
::v-deep .el-pagination.is-background .btn-prev {
  min-width: 34px;
}
::v-deep .el-pagination button {
  height: 34px;
  line-height: 34px;
}
::v-deep .el-pagination.is-background .el-pager li {
  min-width: 34px;
}
::v-deep .el-pager li {
  height: 34px;
  line-height: 34px;
}
.title--button {
  right: 0;
  margin-top: 0.7%;
}
</style>
